var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MultiUnionConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
const schema = {
    $id: 'urn:wisepipe-common-pipe:MultiUnionConfig',
    type: 'object',
    properties: {}
};
let MultiUnionConfig = MultiUnionConfig_1 = class MultiUnionConfig extends ToolConfig {
    constructor(customFormats) {
        super(ToolType.MULTI_UNION, customFormats);
        JSON.validate(this, MultiUnionConfig_1);
    }
    get out() {
        return this.outs[0];
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return MultiUnionConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return MultiUnionConfig_1.outs;
    }
    static get ins() {
        return ['multi'];
    }
    static get outs() {
        return ['default'];
    }
    // eslint-disable-next-line class-methods-use-this
    multiIns(inScope) {
        return [...inScope.names];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.UNION.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.COMBINE], this.ins, this.outs, ['merge', 'combine', 'match', 'append rows'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const schemaKeys = ins.schemas.names.filter((key) => key.startsWith('multi_'));
        const schemas = schemaKeys.map((key) => ins.schemas.at(key));
        const common = MultiUnionConfig_1.getMatchingColumns(schemas);
        const exp = tsb.export(this.out);
        common.forEach((c) => {
            exp.copy(schemaKeys[0], c, true, false, [schemas[0].find((b) => b.name === c.name)]);
        });
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const schemaKeys = scope.schemas.names.filter((key) => key.startsWith('multi_'));
        const schemas = schemaKeys.map((key) => scope.schemas.at(key));
        const length = schemas.length;
        if (length < 2)
            return ToolValidationState.PORT_MISSING_EDGES;
        // Check if there are matching columns across all dataframes
        return MultiUnionConfig_1.getMatchingColumns(schemas).length > 0
            ? ToolValidationState.VALID
            : ToolValidationState.BAD_METADATA;
    }
    isValidForRun(iConfigHelper, scope, pass) {
        return pass ? ToolValidationState.BAD_METADATA : this.isValidForCalc(iConfigHelper, scope);
    }
    static getMatchingColumns(datasets) {
        const matchingColumns = [];
        // Get the intersection of all column names across datasets
        if (datasets.length === 0 || !datasets[0]) {
            return matchingColumns;
        }
        let commonNames = datasets[0].map((col) => col.name);
        for (const dataset of datasets.slice(1)) {
            commonNames = commonNames.filter((name) => dataset.some((col) => col.name === name && col.type === datasets[0].find((d) => d.name === name)?.type));
        }
        // change naming name & type
        for (const name of commonNames) {
            matchingColumns.push(datasets[0].find((col) => col.name === name));
        }
        return matchingColumns;
    }
};
MultiUnionConfig = MultiUnionConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.MULTI_UNION)
], MultiUnionConfig);
export { MultiUnionConfig };
//# sourceMappingURL=multiUnionConfig.js.map